{
  "all": "All",
  "choose": "Choose",
  "notFound": "No data found",
  "orderService": {
    "CLIENT": "Client",
    "BANK": "Bank",
    "COMPLETED": "Completed",
    "INACTIVE": "Inactive",
    "EXPIRED": "Expired"
  },
  "orderStatus": {
    "DRAFT": "In editing",
    "REJECTED": "Rejected",
    "COMPLETED": "Completed",
    "EXPIRED": "Expired",
    "CANCELLED": "Cancelled",
    "READY_TO_COMPLETE": "Awaiting execution",
    "VERIFICATION": "Bank verification",
    "VERIFIED": "Verified",
    "SIGNING": "Awaiting signature",
    "WAITING_FOR_PRINT_ACCEPT": "Awaiting acceptance"
  },
  "orderType": {
    "OWN": "Nostro guarantee",
    "FOREIGN": "Loro guarantee",
    "ANNEX": "Annex",
    "GUARANTEE_MODIFICATION": "Guarantee modification"
  },
  "orderSafeguard": {
    "CONTRACT": "Guarantee agreement",
    "SINGLE_PURPOSE_CREDIT_LINE": "Guarantee credit line",
    "MULTI_PURPOSE_CREDIT_LINE": "Multipurpose financing agreement",
    "GLOBAL_LIMIT_CREDIT_LINE": "Global limit"
  },
  "originTypes": {
    "BANK": "Bank",
    "CLIENT": "Client"
  },
  "creator": {
    "BANK": "Bank",
    "CLIENT": "Client"
  },
  "notificationCode": {
    "OPERATOR_ASSIGNED": "Operator assigned",
    "ORDER_STATUS_VERIFIED": "Verified",
    "ORDER_TO_SIGN": "Awaiting signature",
    "ORDER_STATUS_READY_TO_COMPLETE": "Forwarded for execution",
    "ORDER_STATUS_WAITING_TO_BE_COMPLETED": "Awaiting acceptance",
    "ORDER_STATUS_REJECTED": "Rejected",
    "ORDER_STATUS_COMPLETED": "Completed",
    "OPERATOR_CHANGED": "Operator reassigned"
  },
  "voivodeship": {
    "DOLNOSLASKIE": "Dolnośląskie Voivodship",
    "KUJAWSKOPOMORSKIE": "Kujawsko-Pomorskie Voivodship",
    "LUBELSKIE": "Lubelskie Voivodship",
    "LUBUSKIE": "Lubuskie Voivodship",
    "LODZKIE": "Łódzkie Voivodship",
    "MALOPOLSKIE": "Małopolskie Voivodship",
    "MAZOWIECKIE": "Mazowieckie Voivodship",
    "OPOLSKIE": "Opolskie Voivodship",
    "PODKARPACKIE": "Podkarpackie Voivodship",
    "PODLASKIE": "Podlaskie Voivodship",
    "POMORSKIE": "Pomorskie Voivodship",
    "SLASKIE": "Śląskie Voivodship",
    "SWIETOKRZYSKIE": "Świętokrzyskie Voivodeship",
    "WARMINSKOMAZURSKIE": "Warmińsko-Mazurskie Voivodship",
    "WIELKOPOLSKIE": "Wielkopolskie Voivodship",
    "ZACHODNIOPOMORSKIE": "Zachodniopomorskie Voivodship"
  },
  "boolean": {
    "true": "Yes",
    "false": "No"
  }
}
